import Disclosure from "../utils/Disclosure.js";
import { debounce } from "../utils/Performance";

class SiteHeaderOverlay {

    constructor(element) {
        this.el = element;

        this.subMenuEls = this.el.querySelectorAll(".menu-item__sub-menu");
        this.mainMenuToggles = document.querySelectorAll('[aria-controls="site-header-overlay"]');
        this.mainSearchToggle = document.querySelector('.site-header__utility-menu .btn-search');

        this.init();

        // window.addEventListener(
        //     "resize",
        //     debounce(() => {
        //         this.init();
        //     }, 250),
        // );
    }

    init() {

        const isMobile = window.matchMedia("(max-width: 820px)").matches; 

        // ---------------------------------------------------------------------
        // Handle the full menu toggle
        // ---------------------------------------------------------------------
        if (this.mainMenuToggles.length > 0) {
            this.mainMenuToggles.forEach((toggle) => {
                toggle.addEventListener("click", () => {
                    this.toggleHeader();
                });
            });
        }

        if (isMobile && this.mainSearchToggle) {
            this.mainSearchToggle.addEventListener("click", () => {
                this.toggleHeader(true);
            });
        }

        

        if (isMobile) {

            if (this.subMenuEls.length > 0) {
                this.subMenuEls.forEach((element) => {
                    if (element instanceof Element) {
                        const disclosure = new Disclosure(element, {
                            animate: true,
                            collapseOnAncestorCollapse: true,
                            collapseOnOtherElementsExpand: this.subMenuEls,
                        });

                        disclosure.collapse();

                    }
                });
            }

        } else {

            if (this.subMenuEls.length > 0) {
                this.subMenuEls.forEach((element) => {
                    element.removeAttribute("aria-hidden");
                    element.removeAttribute("hidden");
                });
            }

        }

    }

    toggleHeader(is_search = false) {

        const bodyClasses = document.body.classList;
        const isOpen = bodyClasses.contains('is-open');
        const isMobileSearch = bodyClasses.contains('is-mobile-search');

        if (is_search) {

          if (isOpen && isMobileSearch) {
            this.closeHeader();
            return;
          }

          if (isOpen) {
            bodyClasses.add('is-mobile-search');
            return;
          }

          this.openHeader(true);
          
        } else {

          if (isOpen) {
            this.closeHeader();
          } else {
            this.openHeader(false);
          }

        }
    }

    openHeader(is_search) {
        if(is_search) {
            document.body.classList.add("is-mobile-search");
        }

        document.body.classList.add("is-open");
        this.el.removeAttribute("inert");
        this.el.removeAttribute("aria-hidden");
        document.documentElement.classList.add("no-scroll");
        this.mainMenuToggles.forEach((toggle) => {
            toggle.setAttribute("aria-expanded", "true");
        });

    }

    closeHeader(initial = false) {

        // close the menu
        document.body.classList.remove("is-open");
        document.body.classList.remove("is-mobile-search");

        this.el.setAttribute("inert", true);
        this.el.setAttribute("aria-hidden", "true");
        document.documentElement.classList.remove("no-scroll");

        this.mainMenuToggles.forEach((toggle) => {
            toggle.setAttribute("aria-expanded", "true");
        });

    }

}

document.addEventListener("DOMContentLoaded", () => {
    const element = document.querySelector("#site-header-overlay");

    if (element) {
        new SiteHeaderOverlay(element);
    }
});
